import { performSearch, fetchShareClasses } from "./";
import { isNullOrUndefined, orchestrateBasicSearchResponse, getFundListForFundSearch, safe, getFundListForShareClassSearch } from "../utils";
import { IDataEntityResponse, IAppParams, ISorting, ISearchEntityRequest, EntityType } from "../models";
import { BASE_FUND_FILTER_REQUEST } from "./";
import { INFINITE_SCROLL_LIMIT } from "../config";

export async function fetchFunds(shareClassParentField: string, options: ISearchEntityRequest, appParams: IAppParams, isSearchPrimerCall: string | boolean, sorting: ISorting = { sortOrder: 'ASC' }, infiniteScrollOffset = 0, excludeShareClassTimeseries: boolean = false, stateFunds: IDataEntityResponse | null = null): Promise<IDataEntityResponse> {
	let response = {} as IDataEntityResponse;
	let searchElements = [].concat(options.search);

	let fundList = getFundListForFundSearch(options.search, appParams);
	let sortDirection = sorting.sortOrder;
	if (appParams.sort) {
		if (appParams.sort.toLowerCase() === 'asc') {
			sortDirection = "ASC";
		}
		if (appParams.sort.toLowerCase() === 'desc') {
			sortDirection = "DESC";
		}
	}

	let searchTypes = searchElements.map(item => item.property);
	if (isNullOrUndefined(stateFunds) || searchTypes.indexOf("asset_class") >= 0 || searchTypes.indexOf("regions") >= 0) {
		let fundOptions = Object.assign({ include: { statistics: {}, allocations: {} } }, options,
			{
				fundList,
				search: searchElements.filter(i => BASE_FUND_FILTER_REQUEST.filterProperties.indexOf(i.property) > -1),
				sort: {
					key: "fund_name",
					direction: sortDirection
				}
			});

		let searchResponse = await performSearch(fundOptions, appParams);
		if (searchResponse.error) {
			response.error = searchResponse.error;
		}
		else {
			response = orchestrateBasicSearchResponse(searchResponse.data);
		}
	} else {
		response = stateFunds;
	}
	if (shareClassParentField && safe(() => response.values.length, 0) > 0) {
		let searchValues = response.values.map(value => {
			return value.clientCode;
		});
		fundList = getFundListForShareClassSearch(options.search, appParams);

        let limit;
        if (!isNullOrUndefined(options.limit)) {
            limit = options.limit;
        } else {
            limit = INFINITE_SCROLL_LIMIT;
        }

        let shareClassOptions: ISearchEntityRequest = {
			type: "FUND",
            // fundList,
            start: infiniteScrollOffset,
            limit: limit,
            search: [{
                "property": shareClassParentField,
                "values": searchValues,
                "matchtype": "MATCH"
            },
            ...options.search]
        };

        if (options.limit) {
            shareClassOptions['limit'] = options.limit;
        }

        let shareClassResponse = await fetchShareClasses(shareClassOptions, appParams, isSearchPrimerCall, sorting);
        response.shareClassTotal = shareClassResponse.total;
        for (let fund of response.values) {
            if (!isNullOrUndefined(shareClassResponse) && !isNullOrUndefined(shareClassResponse.values)) {
                fund.shareClasses = shareClassResponse.values.filter(shareClass => shareClass.properties[shareClassParentField] === fund.clientCode);
            } else {
                fund.shareClasses = [];
            }
        }
    }
    return response;
}

export async function fetchShareClassAndFund(shareClassParentField, options, appParams: IAppParams) {
	let response = { shareClass: null, fund: null, error: null };
	let fundList = getFundListForShareClassSearch(options.search, appParams);
	let shareClassOptions = {
		type: "FUND" as EntityType,
		fundList,
		search: [{
			property: 'isin',
			values: [appParams.isin],
			matchtype: "MATCH"
		}],
		start: 0,
		limit: 10
	};

	let targetShareClasses = await fetchShareClasses(shareClassOptions as ISearchEntityRequest, appParams);
	if (targetShareClasses && targetShareClasses.values && targetShareClasses.values.length > 0) {
		response.shareClass = targetShareClasses.values[0];
		let fundOptions = {
			type: "FUND" as EntityType,
			start: 0,
			limit: 10,
			search: [{
				"property": 'client_code',
				"values": [response.shareClass.properties.fund_key],
				"matchtype": "MATCH"
			}]
		};
		let funds = await fetchFunds(shareClassParentField, fundOptions, appParams, false, undefined, undefined, true);
		if (funds && funds.values && funds.values.length > 0) {
			response.fund = funds.values[0];
		}
	}
	return response;
}




// WEBPACK FOOTER //
// ./src/client/data/fund.ts